import React from 'react';

interface SegmentedControlOption {
  value: string;
  label: string;
  badge?: number;
}

interface SegmentedControlProps {
  options: SegmentedControlOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
  options,
  value,
  onChange,
  className = '',
}) => {
  return (
    <div className={`inline-flex items-center bg-gray-100 rounded-lg p-1 ${className}`}>
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`
            px-4 py-2 rounded-md text-sm font-medium transition-all duration-200
            ${
              value === option.value
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
            }
          `}
        >
          <span className="flex items-center gap-2">
            {option.label}
            {option.badge !== undefined && (
              <span
                className={`
                  inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full text-xs font-semibold
                  ${
                    value === option.value
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-300 text-gray-700'
                  }
                `}
              >
                {option.badge}
              </span>
            )}
          </span>
        </button>
      ))}
    </div>
  );
};
